<template>
  <div class="openedHeaderWrapper-backdrop">
    <div
        v-if="!loading"
        class="openedHeaderWrapper">
      <div class="openedHeaderCategory">
        <div class="openedHeaderCategory-title-wrap">
          <h4 class="openedHeaderCategory-title">{{ $t('allCategories') }}</h4>
          <UButton class="openedHeaderCategory-close"></UButton>
        </div>
        <div
            v-for="item of adsCategories"
            :key="item.id"
            class="openedHeaderCategoryItem"
            @mouseover="handleSetCurrentCategory(item.id, item.name[locale])"
            @click="handleNavigate(item.id, item.name[locale])"
        >
          <div
              class="category-item"
              :style="getCategoryStyles(item)"
          >

            <p>{{ item.name[locale] }}</p>
          </div>
          <div
              class="first-arrow-mobile"
              @click.stop="openSecondCategoryMobile"
          ></div>
          <svg
              class="first-arrow"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <mask
                id="mask0_723_13260"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
              <rect
                  y="24"
                  width="24"
                  height="24"
                  transform="rotate(-90 0 24)"
                  fill="#D9D9D9"
              />
            </mask>
            <g mask="url(#mask0_723_13260)">
              <path
                  d="M15.3751 12L9.3751 18L7.9751 16.6L12.5751 12L7.9751 7.4L9.3751 6L15.3751 12Z"
                  fill="#384452"
              />
            </g>
          </svg>
        </div>
      </div>
      <div class="extra-category overflow-y-auto max-h-[500px]">
        <div class="back-arrow">
          <svg
              v-if="selectedAdsType"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              @click.stop="handleAdsSubchapter"
          >
            <mask
                id="mask0_3202_8288"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="20"
                height="20"
            >
              <rect
                  width="20"
                  height="20"
                  fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_3202_8288)">
              <path
                  d="M2.95931 10.0001L9.08431 16.1251C9.29264 16.3334 9.39334 16.5765 9.38639 16.8543C9.37945 17.132 9.27181 17.3751 9.06348 17.5834C8.85514 17.7918 8.61209 17.8959 8.33431 17.8959C8.05653 17.8959 7.81348 17.7918 7.60514 17.5834L1.18848 11.1876C1.02181 11.0209 0.89681 10.8334 0.813477 10.6251C0.730143 10.4168 0.688477 10.2084 0.688477 10.0001C0.688477 9.79176 0.730143 9.58343 0.813477 9.37509C0.89681 9.16676 1.02181 8.97926 1.18848 8.81259L7.60514 2.39593C7.81348 2.18759 8.06001 2.0869 8.34473 2.09384C8.62945 2.10079 8.87598 2.20843 9.08431 2.41676C9.29264 2.62509 9.39681 2.86815 9.39681 3.14593C9.39681 3.4237 9.29264 3.66676 9.08431 3.87509L2.95931 10.0001Z"
                  fill="#1774FF"
              />
            </g>
          </svg>
          <p
              v-if="selectedAdsType"
              class="extra-subchapter-title">
            {{ selectedAdsType.name[locale] }}
          </p>
          <p
              v-else
              class="extra-category-title">
            {{ currentCategoryName }}
          </p>
          <UButton class="openedHeaderCategory-close"></UButton>
        </div>

        <div class="extra-category-content">
          <div v-if="!selectedAdsType">
            <ul
                class="header-item"
                :style="headerItemStyles(adsTypes.length)">
              <li
                  v-for="item of adsTypes"
                  :key="item.id"
                  class="header-item-item"
                  @click="handleGetSubcategory($event, item)"
              >
                {{ item?.name[locale] }}
                <svg
                    v-if="item.adsSubchapters?.length"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                      id="mask0_723_13260"
                      style="mask-type: alpha"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="24"
                      height="24"
                  >
                    <rect
                        y="24"
                        width="24"
                        height="24"
                        transform="rotate(-90 0 24)"
                        fill="#D9D9D9"
                    />
                  </mask>
                  <g mask="url(#mask0_723_13260)">
                    <path
                        d="M15.3751 12L9.3751 18L7.9751 16.6L12.5751 12L7.9751 7.4L9.3751 6L15.3751 12Z"
                        fill="#384452"
                    />
                  </g>
                </svg>
              </li>
            </ul>
          </div>
          <div
              v-if="!selectedAdsType && !currentCategory"
              class="logo-empty flex flex-col items-center justify-center min-h-[300px]"
          >
            <img
                src="../../assets/LogoDoesntExist.svg"
                alt=""
            />
            <p class="empty-desc text-center mt-3">
              {{ $t('didntChoose') }}
            </p>
          </div>

          <div v-if="selectedAdsType">
            <ul
                class="header-item"
                :style="headerItemStyles(adsSubChapters.length)"
            >
              <li
                  v-for="item of adsSubChapters"
                  :key="item.id"
                  class="header-item-item"
                  @click="handleAdsSubchapterNavigate(item)"
              >
                {{ item?.name[locale] }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div
        v-else
        class="openedHeaderWrapper">
      <div class="openedHeaderCategory">
        <USkeleton
            class="h-6 w-full mt-2"
            :ui="{ background: 'bg-[#f1f3f5]' }"
        />
        <USkeleton
            class="h-6 w-full mt-2"
            :ui="{ background: 'bg-[#f1f3f5]' }"
        />
        <USkeleton
            class="h-6 w-full mt-2"
            :ui="{ background: 'bg-[#f1f3f5]' }"
        />
        <USkeleton
            class="h-6 w-full mt-2"
            :ui="{ background: 'bg-[#f1f3f5]' }"
        />
        <USkeleton
            class="h-6 w-full mt-2"
            :ui="{ background: 'bg-[#f1f3f5]' }"
        />
      </div>
      <div class="extra-category overflow-y-auto max-h-[500px]">
        <USkeleton
            class="w-full h-72"
            :ui="{ rounded: 'rounded-md', background: 'bg-[#f1f3f5]' }"
        />
      </div>
    </div>
  </div>
</template>

<script
    setup
    lang="ts">
import {ComparisonOperator} from '@shared';
import type {IAdsSubchapter} from '@shared/ads-subchapter';
import type {IAdsType} from '@shared/ads-type';
import {useI18n} from 'vue-i18n';
import {useAdsCategoryStore} from '~/store/ads-category';
import {useAdsSubChapterStore} from '~/store/ads-subchapter';
import {useAdsTypeStore} from '~/store/ads-type';
import {onMounted, toValue} from 'vue';
import {type IAdsCategory} from '@shared/ads-category';

const {locale} = useI18n();
const subChapterStore = useAdsSubChapterStore();
const {adsSubChapters} = storeToRefs(subChapterStore);
const adsCategoriesStore = useAdsCategoryStore();
const currentCategory = ref<string>('');
const currentCategoryName = ref<string>('');
const selectedAdsType = ref<IAdsType | null>(null);
const adsTypeStore = useAdsTypeStore();
const {adsTypes} = storeToRefs(adsTypeStore);
const {notify} = useNotification();
const adsCategories = ref<IAdsCategory[]>([]);
const {$log} = useNuxtApp();
const {t} = useI18n();
const loading = ref<boolean>(true);
const cachedHeaderCategory = ref<{ [key: string]: IAdsType[] }>({});

const handleNavigate = async(categoryId: string, categoryName: string) => {
  await navigateTo(`/products?category=${categoryId}&categoryName=${categoryName}`);
};

const openSecondCategoryMobile = () => {
  document.querySelector('.extra-category').style.display = 'block';
  document.querySelector('.openedHeaderCategory').style.display = 'none';
  document.querySelector('.extra-category').style.width = '100%';
  document.querySelector('.extra-category').style.minHeight = '500px';
};

const getCategoryStyles = (item: IAdsCategory) => {
  return {backgroundImage: `url(${item?.icon})`};
};

const handleSetCurrentCategory = async(category: string, name: string) => {
  if (currentCategory.value !== category) {
    currentCategoryName.value = name;
    currentCategory.value = category;
    selectedAdsType.value = null;
    const fetchData = async() => {
      await adsTypeStore.filter({
        page: 1,
        limit: 100,
        filter: [
          {
            name: 'category',
            value: category,
            comparison: ComparisonOperator.EQUALS,
          },
        ],
      });
      cachedHeaderCategory.value[category] = toValue(adsTypes.value);
    };

    if (!cachedHeaderCategory.value[category]) {
      await fetchData();
    } else {
      adsTypes.value = cachedHeaderCategory.value[category];
    }
  }
};

const handleAdsSubchapter = () => {
  return (selectedAdsType.value = null);
};

const handleGetSubcategory = (event: Event, data: IAdsType) => {
  if (data.adsSubchapters?.length) {
    event.stopPropagation();
  }
  const subChapters = adsTypes.value.find(
      (item: IAdsType) => item.id === data.id,
  )?.adsSubchapters;
  if (subChapters?.length) {
    adsSubChapters.value = subChapters;
    return (selectedAdsType.value = data);
  }
  navigateTo(`products?category=${data.adsCategory.id}&adsType=${data.id}`);
};

const handleAdsSubchapterNavigate = async(data: IAdsSubchapter) => {
  navigateTo(
      `products?category=${selectedAdsType.value?.adsCategory.id}&adsType=${selectedAdsType.value?.id}&subchapter=${data.id}`,
  );
};

const loadCategories = async() => {
  try {
    const result = await adsCategoriesStore.filter();
    if (!result.success)
      return notify({
        title: result.error?.message as string,
        type: 'error',
      });
    adsCategories.value = result.data?.data as IAdsCategory[];
  } catch (e: any) {
    $log.error(loadCategories.name, e);
  }
};

const headerItemStyles = (length: number) => {
  if (length <= 5) {
    return {
      'grid-template-columns': '300px',
    };
  }

  if (length > 5 && length <= 10) {
    return {
      'grid-template-columns': '200px 200px',
    };
  }
  if (length > 10 && length <= 15) {
    return {
      'grid-template-columns': '200px 200px 200px',
    };
  }
  if (length > 15) {
    return {
      'grid-template-columns': '200px 250px 250px 200px',
    };
  }
};

onMounted(async() => {
  await loadCategories();
  loading.value = false;
});
</script>

<style
    lang="scss"
    scoped>
.openedHeaderWrapper {
  position: absolute;
  background-color: rgba(240, 243, 245, 1);
  width: 100%;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  box-shadow: 0 10px 20px 0 rgba(27, 36, 44, 0.05);
  z-index: 2;
  display: flex;
  padding: 24px;
  gap: 16px;
}

.openedHeaderCategory {
  background-color: #fff;
  width: 200px;
  border-radius: 16px;
  box-shadow: 0 10px 20px 0 rgba(27, 36, 44, 0.05);

  div:last-child {
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
  }
}

.openedHeaderCategoryItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  cursor: pointer;

  &:hover {
    background-color: rgba(23, 116, 255, 0.1);
  }
}

.category-item {
  display: flex;
  align-items: center;
  gap: 10px;
  background-repeat: no-repeat;
  background-position: left center;
  padding-left: 25px;
}

.extra-category {
  background-color: #fff;
  width: 80%;
  box-shadow: 0 10px 20px 0 #1b242c0d;
  border-radius: 16px;
  padding: 12px 16px;
}

.header-item {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  padding: 8px;
  display: grid;
  min-width: 100px;
  max-width: 250px;
  gap: 4px;

  &-item {
    padding: 8px 0;
    transition: all 0.2s;
    display: flex;
    justify-content: space-between;

    &:hover {
      background-color: rgba(237, 242, 255, 1);
      border-radius: 4px;
    }
  }
}

.logo-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 300px; /* adjust based on your layout needs */
}

.empty-desc {
  margin: 0 auto;
  font-size: 16px;
  font-weight: 400;
  line-height: 12px;
  color: #738291;
  text-align: center;
  margin-top: 10px;
}

.extra-category-content {
  max-height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  cursor: pointer;
}

.extra-category-title {
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  color: rgba(23, 116, 255, 1);
  margin-bottom: 8px;
  padding-left: 8px;
}

.extra-subchapter-title {
  font-size: 18px;
  font-weight: 700;
  line-height: 20px;
  color: rgba(23, 116, 255, 1);
}

.back-arrow {
  display: flex;
  gap: 5px;
  align-items: center;
  cursor: pointer;
}

.openedHeaderCategory-title {
  display: none;
}

.first-arrow-mobile {
  display: none;
}

.openedHeaderCategory-title-wrap {
  display: flex;
  align-items: center;
}

.openedHeaderCategory-close {
  display: none;
  margin-left: auto;
  margin-right: 2px;
  width: 50px;
  height: 50px;
  background-color: transparent;
  background-image: url('../../assets/close.svg');
  background-repeat: no-repeat;
  background-position: center;
  border: none;
  box-shadow: none;
}

@media screen and (max-width: 650px) {
  .openedHeaderCategory-close {
    display: block;
  }
  .openedHeaderWrapper-backdrop {
    position: fixed;
    inset: 0;
    background-color: #00000059;
    z-index: 4;
  }
  .openedHeaderWrapper {
    position: fixed;
    bottom: 2px;
    background-color: transparent;
    padding: 10px;
  }
  .openedHeaderCategory-title {
    display: block;
    font-size: 18px;
    font-weight: 700;
    color: #1774ff;
    padding: 10px 15px;
  }
  .extra-category {
    display: none;
  }
  .extra-category-title {
    margin-bottom: 0;
  }
  .openedHeaderCategory {
    width: 100%;
  }
  .first-arrow {
    display: none;
  }
  .first-arrow-mobile {
    display: block;
    width: 25px;
    height: 25px;
    background-color: #0d6efd;
    border-radius: 50%;
    background-image: url('../../assets/arrow-mobile-right.svg');
    background-repeat: no-repeat;
    background-position: center;
  }
  .header-item {
    min-width: 100%;
    display: block;
  }
  .extra-category-content {
    display: block;
  }
  .openedHeaderCategoryItem,
  .header-item {
    font-size: 14px;
  }
}
</style>
